import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CoreService } from './core.service';

@Injectable()
export class ConnectionResolver implements Resolve<any> {
  constructor(private coreService: CoreService) {}

  resolve() {
    console.log('ConnectionResolver. Resolving...');
    return this.coreService.getUserAndConnectSignalR();
  }
}
